// extracted by mini-css-extract-plugin
export default {"icon":"Sidebar_icon__6TBVY","item":"Sidebar_item__wiN+D","header":"Sidebar_header__yGgid","sidebar":"Sidebar_sidebar__zfhso"};